/* Safranwunder – language & region selector + language/market suggestion banner */
(function () {
  'use strict';

  /* ---------- Selector ---------- */
  function submitLang(form, value) {
    var input = form.querySelector('[data-sw-loc-lang]');
    if (!input || !value || input.value === value) return;
    input.value = value;
    form.submit();
  }

  function initSelector(root) {
    if (root.dataset.swLocReady) return;
    root.dataset.swLocReady = '1';
    var form = root.querySelector('[data-sw-loc-form]');
    var trigger = root.querySelector('[data-sw-loc-trigger]');
    var panel = root.querySelector('[data-sw-loc-panel]');
    var demo = root.hasAttribute('data-sw-loc-demo');

    function options() {
      return panel ? Array.prototype.slice.call(panel.querySelectorAll('button, select')) : [];
    }
    function open() {
      if (!panel) return;
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      trigger.setAttribute('aria-expanded', 'true');
      var active = panel.querySelector('.is-active') || options()[0];
      if (active) active.focus({ preventScroll: true });
      document.addEventListener('click', outside, true);
      document.addEventListener('keydown', onKey);
    }
    function close(focusTrigger) {
      if (!panel || panel.hidden) return;
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { panel.hidden = true; }, 160);
      document.removeEventListener('click', outside, true);
      document.removeEventListener('keydown', onKey);
      if (focusTrigger) trigger.focus();
    }
    function outside(e) { if (!root.contains(e.target)) close(false); }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var list = options().filter(function (el) { return el.tagName === 'BUTTON'; });
        var i = list.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        var next = list[(i + (e.key === 'ArrowDown' ? 1 : list.length - 1)) % list.length];
        next.focus();
      }
      if (e.key === 'Tab' && panel && !panel.contains(document.activeElement)) close(false);
    }

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        trigger.getAttribute('aria-expanded') === 'true' ? close(true) : open();
      });
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sw-loc-value],[data-sw-loc-demo-value]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      if (demo || btn.hasAttribute('data-sw-loc-demo-value')) {
        root.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var code = root.querySelector('.sw-loc__code');
        if (code) code.textContent = (btn.getAttribute('data-sw-loc-demo-value') || '').toUpperCase();
        return;
      }
      rememberChoice();
      submitLang(form, btn.getAttribute('data-sw-loc-value'));
    });
    var country = root.querySelector('[data-sw-loc-country]');
    if (country) country.addEventListener('change', function () {
      rememberChoice();
      var lang = form.querySelector('[data-sw-loc-lang]');
      if (lang) lang.value = langForCountry(country.value);
      form.submit();
    });
  }

  /* Language that matches a chosen country (falls back to English for the international market) */
  var COUNTRY_LANG = { DE: 'de', AT: 'de', CH: 'de', LI: 'de', FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr', IT: 'it', SM: 'it', VA: 'it', ES: 'es', AD: 'es' };
  function langForCountry(code) { return COUNTRY_LANG[String(code || '').toUpperCase()] || 'en'; }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sw-loc]').forEach(initSelector);
  }

  /* ---------- Suggestion banner (soft redirect, no forced geo-redirect) ---------- */
  var STORE_KEY = 'sw_loc_suggest_dismissed';
  var COPY = {
    de: { title: 'Lieber auf Deutsch weiter?', text: 'Diese Seite gibt es auch auf Deutsch{c}.', go: 'Auf Deutsch weiter', stay: 'Nein, danke', close: 'Schließen', shop: ' – mit Versand und Preisen für {country}' },
    en: { title: 'Continue in English?', text: 'This page is also available in English{c}.', go: 'Continue in English', stay: 'No, thanks', close: 'Close', shop: ', with shipping and prices for {country}' },
    fr: { title: 'Continuer en français ?', text: 'Cette page est aussi disponible en français{c}.', go: 'Continuer en français', stay: 'Non merci', close: 'Fermer', shop: ', avec livraison et prix pour : {country}' },
    it: { title: 'Continuare in italiano?', text: 'Questa pagina è disponibile anche in italiano{c}.', go: 'Continua in italiano', stay: 'No, grazie', close: 'Chiudi', shop: ', con spedizione e prezzi per {country}' },
    es: { title: '¿Continuar en español?', text: 'Esta página también está disponible en español{c}.', go: 'Continuar en español', stay: 'No, gracias', close: 'Cerrar', shop: ', con envío y precios para {country}' }
  };
  var COUNTRY_COPY = {
    de: { title: 'Shop für {country}?', text: 'Wechsle zum Shop für {country} – mit passenden Versandkosten und Preisen.', go: 'Zum Shop für {country}' },
    en: { title: 'Shopping from {country}?', text: 'Switch to the {country} shop for local shipping and prices.', go: 'Go to {country} shop' },
    fr: { title: 'Vous êtes en {country} ?', text: 'Passez à la boutique {country} pour la livraison et les prix adaptés.', go: 'Boutique {country}' },
    it: { title: 'Ti trovi in {country}?', text: 'Passa al negozio per {country} con spedizione e prezzi dedicati.', go: 'Vai al negozio {country}' },
    es: { title: '¿Estás en {country}?', text: 'Cambia a la tienda de {country} con envío y precios adaptados.', go: 'Ir a la tienda {country}' }
  };

  function dismissed() {
    try {
      var v = localStorage.getItem(STORE_KEY);
      if (v && Date.now() - parseInt(v, 10) < 1000 * 60 * 60 * 24 * 90) return true;
    } catch (e) {}
    return document.cookie.indexOf(STORE_KEY + '=1') !== -1;
  }
  function rememberChoice() {
    try { localStorage.setItem(STORE_KEY, String(Date.now())); } catch (e) {}
    document.cookie = STORE_KEY + '=1; path=/; max-age=' + 60 * 60 * 24 * 90 + '; SameSite=Lax';
  }
  function fill(s, map) { return s.replace(/\{(\w+)\}/g, function (_, k) { return map[k] || ''; }); }

  function initSuggest() {
    var cfg = document.querySelector('[data-sw-loc-suggest-config]');
    if (!cfg || dismissed() || window.Shopify && window.Shopify.designMode) return;
    if (/bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
    var curLang = cfg.getAttribute('data-language');
    var curCountry = cfg.getAttribute('data-country');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(curCountry) + '&language[enabled]=true&language[exclude]=' + encodeURIComponent(curLang);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var s = data && data.suggestions && data.suggestions[0];
        if (!s || !s.parts) return;
        var lang = s.parts.language && s.parts.language.handle;
        var country = s.parts.country && s.parts.country.handle;
        var countryName = s.parts.country && s.parts.country.name;
        if (lang) lang = String(lang).toLowerCase().split('-')[0];
        if (!lang && !country) return;
        render(cfg, lang, country, countryName, curLang);
      })
      .catch(function () {});
  }

  function render(cfg, lang, country, countryName, curLang) {
    var t, title, text, go;
    if (lang && COPY[lang]) {
      t = COPY[lang];
      var extra = country && countryName ? fill(t.shop, { country: countryName }) : '';
      title = t.title; text = fill(t.text, { c: extra }); go = t.go;
    } else if (country && countryName) {
      var base = COPY[curLang] || COPY.en;
      t = { stay: base.stay, close: base.close };
      var cc = COUNTRY_COPY[curLang] || COUNTRY_COPY.en;
      title = fill(cc.title, { country: countryName }); text = fill(cc.text, { country: countryName }); go = fill(cc.go, { country: countryName });
      lang = null;
    } else { return; }

    var form = document.getElementById(cfg.getAttribute('data-form'));
    var el = document.createElement('div');
    el.className = 'sw-loc-suggest';
    var hdr = document.querySelector('[data-sw-header]') || document.body;
    var hs = getComputedStyle(hdr);
    [['--sw-brand', '--sw-loc-gold'], ['--sw-brand-dark', '--sw-loc-gold-dark'], ['--sw-text', '--sw-loc-ink'], ['--sw-text-secondary', '--sw-loc-muted']].forEach(function (p) {
      var v = hs.getPropertyValue(p[0]).trim();
      if (v) el.style.setProperty(p[1], v);
    });
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-live', 'polite');
    if (lang) el.setAttribute('lang', lang);
    el.innerHTML =
      '<div class="sw-loc-suggest__icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.25"/><path d="M2.75 12h18.5"/><path d="M12 2.75c2.6 2.6 3.9 5.7 3.9 9.25s-1.3 6.65-3.9 9.25c-2.6-2.6-3.9-5.7-3.9-9.25S9.4 5.35 12 2.75z"/></svg></div>' +
      '<div><p class="sw-loc-suggest__title"></p><p class="sw-loc-suggest__text"></p></div>' +
      '<button type="button" class="sw-loc-suggest__close"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
      '<div class="sw-loc-suggest__actions"><button type="button" class="sw-loc-suggest__go"></button><button type="button" class="sw-loc-suggest__stay"></button></div>';
    el.querySelector('.sw-loc-suggest__title').textContent = title;
    el.querySelector('.sw-loc-suggest__text').textContent = text;
    el.querySelector('.sw-loc-suggest__go').textContent = go;
    el.querySelector('.sw-loc-suggest__stay').textContent = t.stay;
    el.querySelector('.sw-loc-suggest__close').setAttribute('aria-label', t.close);
    el.setAttribute('aria-label', title);

    function hide() {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }
    el.querySelector('.sw-loc-suggest__go').addEventListener('click', function () {
      rememberChoice();
      if (!form) return hide();
      if (lang) { var li = form.querySelector('[name="language_code"]'); if (li) li.value = lang; }
      if (!lang && country) { var lj = form.querySelector('[name="language_code"]'); if (lj) lj.value = langForCountry(country); }
      if (country) {
        var ci = form.querySelector('[name="country_code"]');
        if (!ci) { ci = document.createElement('input'); ci.type = 'hidden'; ci.name = 'country_code'; form.appendChild(ci); }
        ci.value = country;
      }
      form.submit();
    });
    el.querySelector('.sw-loc-suggest__stay').addEventListener('click', function () { rememberChoice(); hide(); });
    el.querySelector('.sw-loc-suggest__close').addEventListener('click', function () { rememberChoice(); hide(); });
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('is-visible'); }, 1200);
  }

  function boot() { initAll(); initSuggest(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
